import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserAuthProvider } from './context/UserAuthContext';
import UserProtectedRoute from './routes/UserProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import AnnouncementBanner from './components/AnnouncementBanner';
import EmailPromptModal from './components/EmailPromptModal';

// User Pages
import Landing from './pages/Landing';
import Pricing from './pages/Pricing';
import MustRead from './pages/MustRead';
import Terms from './pages/Terms';
import RefundPolicy from './pages/RefundPolicy';
import Contact from './pages/Contact';
import UserLogin from './pages/Login';
import UserSignup from './pages/Signup';
import UserDashboard from './pages/Dashboard';
import Installation from './pages/Installation';
import Guide from './pages/Guide';

function UserApp() {
  return (
    <UserAuthProvider>
      <Router>
        <AnnouncementBanner />
        <EmailPromptModal />
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/must-read" element={<MustRead />} />
          <Route path="/installation" element={<Installation />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<UserLogin />} />
          <Route path="/signup" element={<UserSignup />} />
          
          {/* Protected Routes */}
          <Route 
            path="/dashboard" 
            element={
              <UserProtectedRoute>
                <UserDashboard />
              </UserProtectedRoute>
            } 
          />
          
          {/* 404 - Redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </UserAuthProvider>
  );
}

export default UserApp;
